export default __webpack_public_path__ + "static/media/scroll-button.bef46410.gif";